module.exports = __webpack_public_path__ + "static/img/v72DetailImg.1ba5608.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/v72DetailImg.png
// module id = zKxs
// module chunks = 1